export * from '@lazy-cjk/jp-table-voice';
import getVoiceAll from '@lazy-cjk/jp-table-voice';

export default getVoiceAll;
